(function () {
  'use strict';

  // ─── Konfiguration ────────────────────────────────────────────────────────

  const ATTR_CONSENT_GIVEN    = 'Digitaler Inhalt \u2013 Zustimmung erteilt';
  const ATTR_TEXT_VERSION     = 'Digitaler Inhalt \u2013 Textversion';
  const ATTR_CONSENT_TEXT     = 'Digitaler Inhalt \u2013 Zustimmungstext';
  const ATTR_PRODUCT_ID       = 'Digitaler Inhalt \u2013 Produkt-ID';
  const ATTR_PRODUCT_NAME     = 'Digitaler Inhalt \u2013 Produkt';
  const ATTR_DEVICE_TIMESTAMP = 'Digitaler Inhalt \u2013 Ger\u00e4tezeitstempel';

  const CONSENT_VERSION = 'v1.0';
  const CONSENT_TEXT =
    'Ich stimme ausdr\u00fccklich zu, dass Nathalie-Designs vor Ablauf der ' +
    'Widerrufsfrist mit der Vertragserfüllung beginnt und mir den digitalen ' +
    'Inhalt unmittelbar nach erfolgreicher Bezahlung bereitstellt. Mir ist ' +
    'bekannt, dass mein Widerrufsrecht mit Beginn der Vertragserfüllung erlischt.';

  const CLS_CHECKBOX = 'nd-digital-consent__checkbox';
  const CLS_ERROR    = 'nd-digital-consent__error';
  const CLS_STATUS   = 'nd-digital-consent__status';

  // ─── Dynamische Produktliste ──────────────────────────────────────────────

  let DIGITAL_PRODUCTS = [];

  // ─── Sequenzielle Promise-Warteschlange ───────────────────────────────────

  let _queue = Promise.resolve();

  function enqueue(fn) {
    const task = _queue.then(function () {
      return fn();
    });
    _queue = task.catch(function () {});
    return task;
  }

  // ─── Zustandsvariablen ────────────────────────────────────────────────────

  let consentConfirmed = false;
  let consentRevision  = 0;

  // ─── Instanz-IDs ──────────────────────────────────────────────────────────

  let instanceCounter = 0;

  function assignInstanceIds() {
    document.querySelectorAll('[data-nd-consent-instance]').forEach(function (box) {
      if (box.dataset.ndInstanceId) return;
      instanceCounter++;
      const n = String(instanceCounter);
      box.dataset.ndInstanceId = n;

      const errorEl  = box.querySelector('.' + CLS_ERROR);
      const checkbox = box.querySelector('.' + CLS_CHECKBOX);
      const heading  = box.querySelector('.nd-digital-consent__heading');
      const errorId   = 'nd-consent-error-'   + n;
      const headingId = 'nd-consent-heading-' + n;

      if (errorEl)  errorEl.id  = errorId;
      if (heading)  heading.id  = headingId;
      if (checkbox) checkbox.setAttribute('aria-describedby', errorId);
      box.setAttribute('aria-labelledby', headingId);
      box.removeAttribute('aria-label');
    });
  }

  // ─── Produktdaten laden ───────────────────────────────────────────────────

  function loadDigitalProducts() {
    DIGITAL_PRODUCTS = [];

    const blocks = document.querySelectorAll('[data-nd-digital-products]');
    if (blocks.length === 0) return false;

    const seen = new Set();
    let anyValid = false;

    blocks.forEach(function (el) {
      let raw;
      try {
        raw = JSON.parse(el.textContent);
      } catch (e) {
        console.error('[nd-consent] Produktdaten ungültig:', e);
        return;
      }
      if (!Array.isArray(raw)) return;

      raw.forEach(function (p) {
        if (
          typeof p.id === 'number' &&
          typeof p.title === 'string' &&
          p.title.length > 0 &&
          !seen.has(p.id)
        ) {
          seen.add(p.id);
          DIGITAL_PRODUCTS.push({ id: p.id, title: p.title });
          anyValid = true;
        }
      });
    });

    DIGITAL_PRODUCTS.sort(function (a, b) { return a.id - b.id; });

    return anyValid;
  }

  // ─── Kanonischer ID-String ────────────────────────────────────────────────

  function canonicalProductIds(products) {
    return Array.from(
      new Set(
        products.map(function (p) {
          return String(p.id);
        })
      )
    )
      .sort(function (a, b) {
        return Number(a) - Number(b);
      })
      .join(',');
  }

  // ─── Cart API ─────────────────────────────────────────────────────────────

  function cartRoot() {
    const root = window.Shopify &&
                 window.Shopify.routes &&
                 window.Shopify.routes.root;
    return root ? root.replace(/\/$/, '') : '';
  }

  async function fetchCart() {
    const res = await fetch(cartRoot() + '/cart.js');
    if (!res.ok) throw new Error('Cart-Abruf fehlgeschlagen (HTTP ' + res.status + ').');
    return res.json();
  }

  async function postCartAttributes(attrs) {
    const res = await fetch(cartRoot() + '/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs }),
    });
    if (!res.ok) throw new Error('Speichern fehlgeschlagen (HTTP ' + res.status + ').');

    const data = await res.json();

    for (const key of Object.keys(attrs)) {
      const expected = attrs[key];
      const actual   = (data.attributes && data.attributes[key]) || '';

      if (expected === '') {
        if (actual !== '') {
          throw new Error(
            'Attribut "' + key + '" konnte nicht gelöscht werden. ' +
            'Aktueller Wert: "' + actual + '".'
          );
        }
      } else {
        if (actual !== expected) {
          throw new Error(
            'Attribut "' + key + '" nicht korrekt gespeichert. ' +
            'Erwartet: "' + expected + '", erhalten: "' + actual + '".'
          );
        }
      }
    }
    return data;
  }

  async function saveConsent(deviceTimestamp) {
    const idString = canonicalProductIds(DIGITAL_PRODUCTS);

    if (idString.length === 0) {
      throw new Error(
        '[nd-consent] saveConsent abgebrochen: keine digitalen Produkt-IDs vorhanden.'
      );
    }

    const nameString = DIGITAL_PRODUCTS.map(function (p) { return p.title; }).join(', ');

    return postCartAttributes({
      [ATTR_CONSENT_GIVEN]:    'Ja \u2013 aktiv best\u00e4tigt',
      [ATTR_TEXT_VERSION]:     CONSENT_VERSION,
      [ATTR_CONSENT_TEXT]:     CONSENT_TEXT,
      [ATTR_PRODUCT_ID]:       idString,
      [ATTR_PRODUCT_NAME]:     nameString,
      [ATTR_DEVICE_TIMESTAMP]:
        'Ger\u00e4tezeitstempel (nicht serverseitig): ' + deviceTimestamp +
        ' | Rechtliche Zuordnung \u00fcber Bestellnummer und Bestellzeitpunkt.',
    });
  }

  async function clearConsent() {
    return postCartAttributes({
      [ATTR_CONSENT_GIVEN]:    '',
      [ATTR_TEXT_VERSION]:     '',
      [ATTR_CONSENT_TEXT]:     '',
      [ATTR_PRODUCT_ID]:       '',
      [ATTR_PRODUCT_NAME]:     '',
      [ATTR_DEVICE_TIMESTAMP]: '',
    });
  }

  // ─── Attribut-Verifikation ────────────────────────────────────────────────

  function verifyAttributesInCart(cartData) {
    const attrs = cartData.attributes || {};

    if (attrs[ATTR_CONSENT_GIVEN] !== 'Ja \u2013 aktiv best\u00e4tigt') return false;
    if (attrs[ATTR_TEXT_VERSION]  !== CONSENT_VERSION)                   return false;
    if (attrs[ATTR_CONSENT_TEXT]  !== CONSENT_TEXT)                      return false;

    const savedCanonical   = (attrs[ATTR_PRODUCT_ID] || '').trim();
    const currentCanonical = canonicalProductIds(DIGITAL_PRODUCTS);

    return savedCanonical === currentCanonical;
  }

  function cartHasDigital(cartData) {
    const ids = new Set(DIGITAL_PRODUCTS.map(function (p) { return p.id; }));
    return Array.isArray(cartData.items) &&
      cartData.items.some(function (item) {
        return ids.has(item.product_id);
      });
  }

  // ─── DOM-Hilfsfunktionen ──────────────────────────────────────────────────

  function allCheckboxes() {
    return Array.from(document.querySelectorAll('.' + CLS_CHECKBOX));
  }

  function setErrorVisible(visible, customText) {
    document.querySelectorAll('.' + CLS_ERROR).forEach(function (el) {
      el.style.display = visible ? 'block' : 'none';
      if (customText !== undefined) el.textContent = customText;
    });
  }

  function setStatus(text) {
    document.querySelectorAll('.' + CLS_STATUS).forEach(function (el) {
      el.textContent = text;
    });
  }

  function setCheckoutBlocked(blocked) {
    document.querySelectorAll('[data-nd-blocked-hint]').forEach(function (btn) {
      btn.style.display = blocked ? '' : 'none';
    });

    document.querySelectorAll('[data-nd-checkout-btn]').forEach(function (btn) {
      if (blocked) {
        btn.disabled = true;
        btn.setAttribute('aria-disabled', 'true');
        btn.style.display = 'none';
      } else {
        btn.disabled = false;
        btn.removeAttribute('aria-disabled');
        btn.style.display = '';
      }
    });

    document.querySelectorAll('[data-nd-express-btns]').forEach(function (el) {
      if (blocked) {
        el.setAttribute('inert', '');
        el.setAttribute('aria-hidden', 'true');
        el.style.display = 'none';
      } else {
        el.removeAttribute('inert');
        el.removeAttribute('aria-hidden');
        el.style.display = '';
      }
    });

    const cartForm = document.getElementById('cart-form');
    if (cartForm) {
      if (blocked) {
        cartForm.dataset.ndBlocked = 'true';
      } else {
        delete cartForm.dataset.ndBlocked;
      }
    }
  }

  // ─── handleCartState ──────────────────────────────────────────────────────

  async function handleCartState() {
    await enqueue(async function () {
      let cartData;
      try {
        cartData = await fetchCart();
      } catch (e) {
        setCheckoutBlocked(true);
        setStatus('Warenkorb konnte nicht geprüft werden. Bitte Seite neu laden.');
        return;
      }

      const hasDigital = cartHasDigital(cartData);

      if (!hasDigital) {
        consentConfirmed = false;
        setCheckoutBlocked(false);

        let clearOk = false;
        try {
          await clearConsent();
          clearOk = true;
        } catch (e) {
          console.warn('[nd-consent] clearConsent fehlgeschlagen:', e.message);
          try {
            const recheckCart = await fetchCart();
            const stillHasAttr = recheckCart.attributes &&
              recheckCart.attributes[ATTR_CONSENT_GIVEN] ===
                'Ja \u2013 aktiv best\u00e4tigt';
            if (stillHasAttr) {
              setStatus(
                'Zustimmungsdaten konnten nicht vollständig gelöscht werden. ' +
                'Bitte Seite neu laden.'
              );
            }
          } catch (recheckErr) {
            setStatus('Warenkorb konnte nicht geprüft werden. Bitte Seite neu laden.');
          }
        }
        if (clearOk) setStatus('');
        return;
      }

      assignInstanceIds();

      if (consentConfirmed) {
        const attrOk = verifyAttributesInCart(cartData);
        if (attrOk) return;
        consentConfirmed = false;
      }

      try {
        await clearConsent();
      } catch (e) {
        setCheckoutBlocked(true);
        setErrorVisible(true,
          'Fehler beim Zurücksetzen der Zustimmung. Bitte Seite neu laden.');
        return;
      }

      allCheckboxes().forEach(function (cb) { cb.checked = false; });
      setCheckoutBlocked(true);
      setErrorVisible(false);
      setStatus('');
    });
  }

  function safeHandleCartState() {
    handleCartState().catch(function (err) {
      console.error('[nd-consent] handleCartState fehlgeschlagen:', err);
      setCheckoutBlocked(true);
      setStatus('Fehler beim Prüfen des Warenkorbs. Bitte Seite neu laden.');
    });
  }

  // ─── Event-Delegation ─────────────────────────────────────────────────────

  let listenersAttached = false;

  function attachListeners() {
    if (listenersAttached) return;
    listenersAttached = true;

    document.addEventListener('change', function (e) {
      if (!e.target || !e.target.classList.contains(CLS_CHECKBOX)) return;

      const checked = e.target.checked;

      allCheckboxes().forEach(function (cb) {
        if (cb !== e.target) cb.checked = checked;
      });

      if (!checked) {
        consentRevision++;
        consentConfirmed = false;
        setCheckoutBlocked(true);
        setErrorVisible(false);
        setStatus('');

        enqueue(async function () {
          consentConfirmed = false;
          try {
            await clearConsent();
          } catch (err) {
            setStatus(
              'Zustimmung konnte nicht zurückgesetzt werden. ' +
              'Bitte Seite neu laden.'
            );
          }
        }).catch(function (err) {
          console.error('[nd-consent] Abwählen fehlgeschlagen:', err);
        });
        return;
      }

      const operationRevision = ++consentRevision;

      setCheckoutBlocked(true);
      setErrorVisible(false);
      setStatus('Zustimmung wird gespeichert \u2026');

      const deviceTimestamp = new Date().toISOString();

      enqueue(async function () {

        try {
          await saveConsent(deviceTimestamp);
        } catch (err) {
          if (operationRevision !== consentRevision) return;
          allCheckboxes().forEach(function (cb) { cb.checked = false; });
          setCheckoutBlocked(true);
          setStatus('');
          setErrorVisible(true,
            'Deine Zustimmung konnte gerade nicht gespeichert werden. ' +
            'Bitte versuche es erneut.');
          return;
        }

        if (operationRevision !== consentRevision) return;

        let cartData;
        try {
          cartData = await fetchCart();
        } catch (err) {
          if (operationRevision !== consentRevision) return;
          allCheckboxes().forEach(function (cb) { cb.checked = false; });
          setCheckoutBlocked(true);
          setStatus('');
          setErrorVisible(true,
            'Warenkorb konnte nach dem Speichern nicht geprüft werden. ' +
            'Bitte Seite neu laden.');
          return;
        }

        if (operationRevision !== consentRevision) return;

        if (!cartHasDigital(cartData)) {
          consentRevision++;
          consentConfirmed = false;
          allCheckboxes().forEach(function (cb) { cb.checked = false; });
          setCheckoutBlocked(false);

          let clearOk = false;
          try {
            await clearConsent();
            clearOk = true;
          } catch (clearErr) {
            console.warn(
              '[nd-consent] clearConsent nach Handout-Entfernung fehlgeschlagen:',
              clearErr.message
            );
            try {
              const recheckCart = await fetchCart();
              const stillHasAttr = recheckCart.attributes &&
                recheckCart.attributes[ATTR_CONSENT_GIVEN] ===
                  'Ja \u2013 aktiv best\u00e4tigt';
              if (stillHasAttr) {
                setStatus(
                  'Zustimmungsdaten konnten nicht vollständig gelöscht werden. ' +
                  'Bitte Seite neu laden.'
                );
              }
            } catch (recheckErr) {
              setStatus('Warenkorb konnte nicht geprüft werden. Bitte Seite neu laden.');
            }
          }
          if (clearOk) {
            setStatus('Das digitale Produkt wurde aus dem Warenkorb entfernt.');
          }
          return;
        }

        if (!verifyAttributesInCart(cartData)) {
          if (operationRevision !== consentRevision) return;
          allCheckboxes().forEach(function (cb) { cb.checked = false; });
          setCheckoutBlocked(true);
          setStatus('');
          setErrorVisible(true,
            'Zustimmung konnte nicht verifiziert werden. Bitte versuche es erneut.');
          return;
        }

        if (operationRevision !== consentRevision) return;

        consentConfirmed = true;
        setCheckoutBlocked(false);
        setStatus('\u2713 Zustimmung gespeichert.');
        setErrorVisible(false);

      }).catch(function (err) {
        console.error('[nd-consent] Checkbox-Handler fehlgeschlagen:', err);
        if (operationRevision !== consentRevision) return;
        allCheckboxes().forEach(function (cb) { cb.checked = false; });
        setCheckoutBlocked(true);
        setStatus('');
        setErrorVisible(true,
          'Ein unerwarteter Fehler ist aufgetreten. Bitte Seite neu laden.');
      });
    });

    document.addEventListener('submit', function (e) {
      const form = e.target;
      if (!form || form.id !== 'cart-form') return;
      if (!form.dataset.ndBlocked) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      setErrorVisible(true);
      const firstError = document.querySelector('.' + CLS_ERROR);
      if (firstError) firstError.focus();
    }, true);

    document.addEventListener('click', function (e) {
      const btn = e.target && e.target.closest('[data-nd-blocked-hint]');
      if (!btn) return;
      e.preventDefault();
      setErrorVisible(true);
      const firstError = document.querySelector('.' + CLS_ERROR);
      if (firstError) firstError.focus();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      const btn = e.target && e.target.closest('[data-nd-blocked-hint]');
      if (!btn) return;
      e.preventDefault();
      setErrorVisible(true);
    });

    document.addEventListener('cart:update', function () {
      consentRevision++;
      consentConfirmed = false;
      setCheckoutBlocked(true);
      allCheckboxes().forEach(function (cb) { cb.checked = false; });
      setErrorVisible(false);
      setStatus('');

      setTimeout(function () {
        const loaded = loadDigitalProducts();
        const hasInstance = !!document.querySelector('[data-nd-consent-instance]');

        if (hasInstance && !loaded) {
          setCheckoutBlocked(true);
          setStatus(
            'Digitale Produktdaten konnten nicht geladen werden. ' +
            'Bitte Seite neu laden.'
          );
          return;
        }

        enqueue(async function () {
          consentConfirmed = false;
          try {
            await clearConsent();
          } catch (e) {
            console.warn(
              '[nd-consent] clearConsent nach cart:update fehlgeschlagen:',
              e.message
            );
          }
        }).catch(function (err) {
          console.error('[nd-consent] Queue-Fehler nach cart:update:', err);
        }).finally(function () {
          setTimeout(safeHandleCartState, 50);
        });
      }, 100);
    });
  }

  // ─── Initialisierung ──────────────────────────────────────────────────────

  function init() {
    const loaded = loadDigitalProducts();
    const hasInstance = !!document.querySelector('[data-nd-consent-instance]');

    if (hasInstance && !loaded) {
      setCheckoutBlocked(true);
      setStatus(
        'Digitale Produktdaten konnten nicht geladen werden. ' +
        'Bitte Seite neu laden.'
      );
      attachListeners();
      return;
    }

    attachListeners();
    safeHandleCartState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
